import { render, staticRenderFns } from "./screenNotas.vue?vue&type=template&id=11eed7ab"
import script from "./screenNotas.vue?vue&type=script&lang=js"
export * from "./screenNotas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports